/**
 * @method removeAccents
 * @description removes all accents and diacritics from a given String
 * Normalizing to NFD Unicode normal form decomposes combined graphemes
 * into the combination of simple ones.
 * Eg: 'Tatuapé' - The é of Tatuapé ends up expressed as e +  ´.
 * Using a regex character class to match the U+0300 → U+036F range, it becames
 * trivial to globally get rid of the diacritics, which the Unicode standard conveniently
 * groups as the Combining Diacritical Marks Unicode block.
 * @param str String
 * @returns String with no accents or diacritics
 */
export default str => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
